import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Login from './Login';
import Logout from './Logout';
import StudentPassportPage from '../StudentPassportPage';
import StudentTestPage from '../StudentTestPage';

const AuthBasicRoutes = ({ basePath, match }) => {
  const url = basePath || match.url;

  return (
    <Switch>
      <Route path={`${url}/student-test`} exact component={StudentTestPage} />
      <Route path={`${url}/student-passport`} exact component={StudentPassportPage} />
      <Route path={`${url}/login`} exact component={Login} />
      <Route path={url} exact component={Login} />
      <Route path={`${url}/logout`} exact component={Logout} />
      <Redirect to={`${url}/login`} />
    </Switch>
  );
};

AuthBasicRoutes.propTypes = {
  basePath: PropTypes.string,
  match: PropTypes.object.isRequired
};

AuthBasicRoutes.defaultProps = {
  basePath: null
};

export default withRouter(AuthBasicRoutes);
